import { render, staticRenderFns } from "./backUserMoneyAudit.vue?vue&type=template&id=527f4156&scoped=true&"
import script from "./backUserMoneyAudit.vue?vue&type=script&lang=js&"
export * from "./backUserMoneyAudit.vue?vue&type=script&lang=js&"
import style0 from "./backUserMoneyAudit.vue?vue&type=style&index=0&id=527f4156&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f4156",
  null
  
)

export default component.exports